function storageAvailable(type: string) {
    let storage;
    try {
        storage = (window as any)[type];
        const x = '__storage_test__';
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e instanceof DOMException && (
                // everything except Firefox
            e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
            // acknowledge QuotaExceededError only if there's something already stored
            (storage && storage.length !== 0);
    }
}

class DummyBrowserStorage implements Storage {
    [name: string]: any;

    private data: { [name: string]: string };

    constructor(data: { [name: string]: string }) {
        this.data = data;
    }

    get length(): number {
        return Object.keys(this.data).length;
    }

    public clear(): void {
        this.data = {};
    }

    public getItem(key: string): string | null {
        return this.data[key];
    }

    public key(index: number): string | null {
        const keys = Object.keys(this.data);

        return index < 0 || index >= keys.length ? null : keys[index];
    }

    public removeItem(key: string): void {
        delete this.data[key];
    }

    public setItem(key: string, value: string): void {
        this.data[key] = value;
    }

}

export function getBrowserStorage(): Storage {
    if (storageAvailable('localStorage')) {
        return window.localStorage;
    } else if (storageAvailable('sessionStorage')) {
        return window.sessionStorage;
    } else {
        return new DummyBrowserStorage({});
    }
}
